import { Row, Table, Divider, Badge, Col, Empty, Tag } from 'antd'
import React from 'react'
import './index.css'
export default function SearchTwo({ resultInfo }) {

    // 预测字段可能使用分号、逗号或竖线保存多个转录本结果，摘要仅展示首个有效值
    const firstPredictionValue = (value) => {
        if (value === undefined || value === null || value === '') return '-';
        const firstValue = String(value)
            .split(/[;,|&]/)
            .map(item => item.trim())
            .find(item => item && item !== '.') ?? '-';
        if (firstValue === '-') return '-';

        const numericValue = Number(firstValue);
        if (!Number.isFinite(numericValue)) return firstValue;
        // 预测分数字段最多保留4位小数，整数不强制补零
        return Number(numericValue.toFixed(4)).toString();
    };

    const dbsnfpItem = () => {
        const initialItems = [
            {
                key: '1',
                label: "PolyPhen",
                value: firstPredictionValue(resultInfo.VEP_PolyPhen)
            }, {
                key: '2',
                label: "CADD",
                value: firstPredictionValue(resultInfo.DBSNFP?.DBNSFP_CADD_PHRED)
            },
            {
                key: '8',
                label: "AlphaMissense",
                value: firstPredictionValue(resultInfo.DBSNFP?.DBNSFP_AlphaMissense_score),
            },
            {
                key: '9',
                label: "EVE",
                value: firstPredictionValue(resultInfo.DBSNFP?.DBNSFP_EVE_score),
            }, {
                key: '5',
                label: "PolyPhen-2 HDIV",
                value: firstPredictionValue(resultInfo.DBSNFP?.DBNSFP_POLYPHEN2_HDIV_SCORE),
            }, {
                key: '6',
                label: "PolyPhen-2 HVAR",
                value: firstPredictionValue(resultInfo.DBSNFP?.DBNSFP_POLYPHEN2_HVAR_SCORE),
            }, {
                key: '3',
                label: "SIFT",
                value: firstPredictionValue(resultInfo.DBSNFP?.DBNSFP_SIFT_SCORE),
            }, {
                key: '7',
                label: "GERP",
                value: firstPredictionValue(resultInfo.DBSNFP?.DBNSFP_GERP_RS),
            }, {
                key: '4',
                label: "REVEL",
                value: firstPredictionValue(resultInfo.DBSNFP?.DBNSFP_REVEL_SCORE),
            }, {
                key: '13',
                label: "MutScore",
                value: firstPredictionValue(resultInfo.DBSNFP?.DBNSFP_MutScore_score),
            },
            {
                key: '9',
                label: "SpliceAI Acceptor Loss",
                value: firstPredictionValue(resultInfo.SpliceAI?.SpliceAI_pred_DS_AL),
            },
            {
                key: '10',
                label: "SpliceAI Donor Loss",
                value: firstPredictionValue(resultInfo.SpliceAI?.SpliceAI_pred_DS_DL),
            },
            {
                key: '11',
                label: "SpliceAI Acceptor Gain",
                value: firstPredictionValue(resultInfo.SpliceAI?.SpliceAI_pred_DS_AG),
            },
            {
                key: '12',
                label: "SpliceAI Donor Gain",
                value: firstPredictionValue(resultInfo.SpliceAI?.SpliceAI_pred_DS_DG),
            },

        ];
        return initialItems;
    };

    const rsId = firstPredictionValue(resultInfo?.VEP_Existing_variation);
    const dataSourceInfo = () => {
        if (resultInfo) {
            const listRes = resultInfo?.vepList || [];
            return listRes.map((item, index) => ({
                key: index,
                dbsnp: item.VEP_Existing_variation,
                symbol: item.VEP_SYMBOL,
                hgvsc: item.VEP_HGVSc,
                hgvsConsequence: item.VEP_HGVSp?.split(':')[0],
                protein: item.VEP_HGVSp ? item.VEP_HGVSp.split(':').length > 1 ? item.VEP_HGVSp.split(':')[1] : '' : '',
                select: item.VEP_MANE_SELECT,
                transcript: item.VEP_Feature,
                cDNA: item.VEP_HGVSc ? item.VEP_HGVSc.split(':').length > 1 ? item.VEP_HGVSc.split(':')[1] : '' : '',
                consequence: item.VEP_Consequence,
                sift: item.VEP_SIFT,
                polyphen: item.Polyphen,
                pubmed: item.VEP_PUBMED,
                vepPick: item.VEP_PICK
            }));
        } else {
            return [];
        }
    }

    const tableTitle = (value) => {
        return (<div style={{ fontSize: '18px' }}>
            {value}
        </div>
        )
    }

    const tableValue = (text) => {
        return (
            <span className="detail-table-value">
                {text ?? '-'}
            </span>
        )
    }

    // 从ClinVar变异来源字段中提取OMIM编号，例如 "ClinGen...OMIM:121011.0023..."
    const clinvarOmim = resultInfo?.clinvar_CLNVI?.match(/OMIM:\s*[\d.]+/i)?.[0];
    const hgmdPhenotype = resultInfo?.HGMD?.PHEN;
    const clinvarDiseaseName = resultInfo?.clinvar_CLNDN;

    // 频率数据使用副本排序，避免直接修改接口返回的数据
    const frequencyData = [...(resultInfo?.frequenciesList || [])].sort((a, b) => {
        const nameA = a?.name || '';
        const nameB = b?.name || '';
        const isGA = nameA.toLowerCase().startsWith('g');
        const isGB = nameB.toLowerCase().startsWith('g');

        if (isGA && !isGB) return -1;
        if (!isGA && isGB) return 1;
        return nameA.localeCompare(nameB);
    });

    const transcriptData = dataSourceInfo();
    const isPickedTranscript = (record) => String(record?.vepPick ?? '') === '1';
    const emptyTable = (description) => (
        <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={description}
        />
    );

    // 将分号、竖线或逗号连接的表型文本拆分为独立条目并去重，避免长文本撑破卡片
    const normalizeDelimitedItems = (value, splitReg = /[;|]/) => {
        if (!value) {
            return [];
        }
        const itemMap = new Map();
        String(value)
            .replaceAll('"', '')
            .split(splitReg)
            .map(item => item.trim())
            .filter(Boolean)
            .map(item => item.replaceAll('_', ' '))
            .forEach(item => {
                // GenCC等疾病名称可能重复出现，按文本小写去重并保留首次展示格式
                const uniqueKey = item.toLowerCase();
                if (!itemMap.has(uniqueKey)) {
                    itemMap.set(uniqueKey, item);
                }
            });
        return Array.from(itemMap.values());
    };

    const renderPhenotypeItems = (value) => {
        const items = normalizeDelimitedItems(value);
        if (items.length === 0) {
            return <span className="phenotype-empty">No phenotype information available</span>;
        }
        return (
            <div className="phenotype-items">
                {items.map((item, index) => (
                    <span className="phenotype-item" key={`${item}-${index}`}>
                        {item}
                    </span>
                ))}
            </div>
        );
    };

    // ClinVar疾病名称中移除 not provided，避免展示无意义占位表型
    const clinvarDiseaseDisplay = normalizeDelimitedItems(clinvarDiseaseName)
        .filter(item => item.toLowerCase() !== 'not provided')
        .join('; ');

    const renderClassificationNote = (label, value, splitReg) => {
        const items = normalizeDelimitedItems(value, splitReg);
        if (items.length === 0) {
            return null;
        }
        return (
            <div className="classification-note">
                <span>{label}</span>
                <div className="classification-note-items">
                    {items.map((item, index) => (
                        <em key={`${label}-${item}-${index}`}>{item}</em>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <Row style={{ width: '100%' }} justify={'center'}>
            <Col xs={20} sm={20}>
                <Divider />
            </Col>
            <Col xs={20} sm={20}>
                <span className='title_name' style={{ display: 'flex', alignItems: 'center', fontWeight: '700' }}>
                    <img src='https://gsrd-server.tos-cn-beijing.volces.com/gene8.png'
                        style={{ height: '30px', width: '30px', marginRight: '10px' }}
                    />
                    Allele Frequencies in Public Databases
                </span>
                <p className="search-section-description">
                    Allele counts and frequencies from public reference datasets.
                </p>
            </Col>
            <Col xs={20} sm={20}>
                {/* 频率列表前置到变异信息上方，方便先查看群体频率摘要 */}
                <section className="detail-table-panel">
                    <div className="detail-table-heading">
                        <p></p>
                        <Tag className="detail-count-tag">{frequencyData.length} sources</Tag>
                    </div>
                    <Table
                        className="detail-data-table frequency-table"
                        size='middle'
                        columns={[
                            {
                                title: tableTitle('Source'),
                                dataIndex: 'name',
                                key: 'name',
                                width: 240,
                                fixed: 'left',
                                render: (value) => <span className="frequency-source">{value || '-'}</span>
                            },
                            {
                                title: tableTitle('Allele Count'),
                                dataIndex: 'AC',
                                key: 'AC',
                                render: (value) => tableValue(value)
                            },
                            {
                                title: tableTitle('Allele Number'),
                                dataIndex: 'AN',
                                key: 'AN',
                                render: (value) => tableValue(value)
                            },
                            {
                                title: tableTitle('Allele Frequency'),
                                dataIndex: 'AF',
                                key: 'AF',
                                render: (value) => tableValue(value)
                            },
                            {
                                title: tableTitle('Number of Homozygotes'),
                                dataIndex: 'Hom',
                                key: 'Hom',
                                render: (value) => tableValue(value)
                            },
                        ]}
                        scroll={{ x: 900 }}
                        dataSource={frequencyData}
                        pagination={frequencyData.length > 12 ? {
                            pageSize: 12,
                            showSizeChanger: false,
                            showTotal: total => `${total} sources`
                        } : false}
                        locale={{ emptyText: emptyTable('No population frequency data available') }}
                        onRow={(_, index) => ({ className: index % 2 ? 'striped-row' : '' })}
                    />
                </section>
            </Col>
            <Col xs={20} sm={20}>
                <Divider />
            </Col>
            <Col xs={20} sm={20}>
                <span className='title_name' style={{ display: 'flex', alignItems: 'center' }}>
                    <img src='https://gsrd-server.tos-cn-beijing.volces.com/gene2.png'
                        style={{ height: '30px', width: '30px', marginRight: '10px' }}
                    />
                    Variant Annotation
                </span>
            </Col>
            <Col xs={20} sm={20}>
                {/* 外部数据库入口统一为快捷链接卡片 */}
                <Row justify={"space-between"} className="variant-link-grid">
                    <div className="variant-link-item">
                        <span className='title_name_sub' >
                            Genomic Position (GRCh38):
                        </span>
                        <Badge dot>
                            <a className='content_name'
                                target="_blank"
                                href={'https://genome.ucsc.edu/cgi-bin/hgTracks?db=hg38&lastVirtModeType=default&lastVirtModeExtraState=&virtModeType=default&virtMode=0&nonVirtPosition=&position=chr' + resultInfo?.searchInfo.searchChr + ':' + (resultInfo?.searchInfo.searchPos - 25) + '-' + (resultInfo?.searchInfo.searchPos + 25)}>
                                {resultInfo?.searchInfo.searchChr
                                    + ':' +
                                    resultInfo?.searchInfo.searchPos}
                            </a>
                        </Badge>
                    </div>
                    <div className="variant-link-item">
                        <span className='title_name_sub' >
                            dbSNP:
                        </span>
                        <Badge dot>
                            <a href={'https://www.ncbi.nlm.nih.gov/snp/' + rsId}
                                target="_blank"
                                style={{
                                    fontSize: '18px',
                                    backgroundColor: 'aliceblue',
                                    margin: '6px',
                                    padding: '2px 5px',
                                    borderRadius: '5px',
                                    color: '#0d6f82',
                                }}
                            >
                                {rsId}
                            </a>
                        </Badge>
                    </div>
                    <div className="variant-link-item">
                        <span className='title_name_sub' >
                            Genome Browser:
                        </span>
                        <Badge dot>
                            <a href={'http://genome.ucsc.edu/cgi-bin/hgSearch?search=' + rsId + '&db=hg38'}
                                target="_blank"
                                style={{
                                    fontSize: '18px',
                                    backgroundColor: 'aliceblue',
                                    margin: '6px',
                                    padding: '2px 5px',
                                    borderRadius: '5px',
                                    color: '#0d6f82'
                                }}
                            >
                                {rsId}
                            </a>
                        </Badge>
                    </div>
                    <div className="variant-link-item">
                        <span className='title_name_sub' >
                            LitVar:
                        </span>
                        <Badge dot>
                            <a href={'https://www.ncbi.nlm.nih.gov/research/litvar2/docsum?variant=litvar@' + rsId + '%23%23&query=' + rsId}
                                target="_blank"
                                style={{
                                    fontSize: '18px',
                                    backgroundColor: 'aliceblue',
                                    margin: '6px',
                                    padding: '2px 5px',
                                    borderRadius: '5px',
                                    color: '#0d6f82'
                                }}
                            >
                                {rsId}
                            </a>
                        </Badge>
                    </div>
                </Row >
            </Col>

            <Col xs={20} sm={20}>
                {/* 转录本表格增加摘要、重点标识和独立空态，方便快速浏览 */}
                <section className="detail-table-panel">
                    <div className="detail-table-heading">
                        <div>
                            <h3>Transcript annotations</h3>
                            <p>Functional annotations and allele metrics for this variant.</p>
                        </div>
                        <Tag className="detail-count-tag">{transcriptData.length} records</Tag>
                    </div>
                    <Table
                        className="detail-data-table transcript-annotation-table"
                        size='middle'
                        scroll={{ x: 1120 }}
                        dataSource={transcriptData}
                        pagination={transcriptData.length > 10 ? { pageSize: 10, showSizeChanger: false } : false}
                        locale={{ emptyText: emptyTable('No transcript annotation data available') }}
                        onRow={(record, index) => ({
                            className: `${isPickedTranscript(record) ? 'highlight-row' : ''} ${index % 2 ? 'striped-row' : ''}`,
                        })}
                        columns={[
                            {
                                title: tableTitle('Transcript'),
                                dataIndex: 'transcript',
                                key: 'transcript',
                                width: 190,
                                fixed: 'left',
                                render: (value, record) => (
                                    <div className="transcript-cell">
                                        {value ?
                                            <a
                                                className="detail-table-code detail-table-link"
                                                href={`https://www.ensembl.org/Human/Search/Results?q=${encodeURIComponent(value)};facet_feature_type=;site=ensembl;facet_species=Human`}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                {value}
                                            </a> :
                                            <span className="detail-table-code">-</span>}
                                    </div>
                                )
                            },
                            {
                                title: tableTitle('Gene'),
                                dataIndex: 'symbol',
                                key: 'symbol',
                                render: (text) => (
                                    text ?
                                        <a
                                            className="gene-symbol detail-table-link"
                                            href={`https://www.genecards.org/card/${encodeURIComponent(text)}`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {text}
                                        </a> :
                                        <span className="gene-symbol">-</span>
                                )
                            },
                            {
                                title: tableTitle('HGVSc.'),
                                dataIndex: 'cDNA',
                                key: 'cDNA',
                                width: 240,
                                render: (value) => tableValue(value)
                            },
                            {
                                title: tableTitle('HGVSp.'),
                                dataIndex: 'protein',
                                key: 'protein',
                                width: 220,
                                render: (value) => tableValue(value)
                            },
                            {
                                title: tableTitle('Consequence'),
                                dataIndex: 'consequence',
                                key: 'Consequence',
                                render: (value) => tableValue(value)
                            },
                            {
                                title: tableTitle('MANE select'),
                                dataIndex: 'select',
                                key: 'select',
                                width: 210,
                                render: (value, record) => (
                                    <div className="mane-select-cell">
                                        {/* MANE select 列集中展示 MANE 信息和 selected 标识，避免 Transcript 列过度拥挤 */}
                                        {tableValue(value)}
                                        {isPickedTranscript(record) && <Tag color="gold">Selected</Tag>}
                                    </div>
                                )
                            }
                        ]}
                    />
                </section>
            </Col>
            <Col xs={20} sm={20}>
                <Divider />
            </Col>
            <Col xs={20} sm={20}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} className="detail-info-panel pathogenicity-panel">
                        <span className='title_name' style={{ display: 'flex', alignItems: 'center', fontWeight: '700' }}>
                            <img src='https://gsrd-server.tos-cn-beijing.volces.com/gene5.png'
                                style={{ height: '30px', width: '30px', marginRight: '10px' }}
                            />
                            Variant classification
                        </span>
                        {/* 内容增多后使用横向证据卡，给疾病/表型标签更多展示空间 */}
                        <div className="classification-grid">
                            <div className="classification-card">
                                <div className="classification-card-head">
                                    <span>HGMD</span>
                                    <strong>{resultInfo.HGMD?.CLASS === 'DM' ? 'Pathogenic' :
                                        resultInfo.HGMD?.CLASS === 'DM?' ? 'Likely Pathogenic' : '-'}</strong>
                                </div>
                                {renderClassificationNote('Primary phenotype', hgmdPhenotype, /[,;|]/)}
                            </div>
                            <div className="classification-card">
                                <div className="classification-card-head">
                                    <span>ClinVar</span>
                                    <strong>{resultInfo.clinvar_CLNSIG?.replaceAll('|', ';') ?? '-'}</strong>
                                </div>
                                {renderClassificationNote('Preferred disease name', clinvarDiseaseDisplay, /[;|]/)}
                                {clinvarOmim && <em className="clinvar-omim">{clinvarOmim}</em>}
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} className="detail-info-panel">
                        <span className='title_name' style={{ display: 'flex', alignItems: 'center', fontWeight: '700' }}>
                            <img src='https://gsrd-server.tos-cn-beijing.volces.com/gene6.png'
                                style={{ height: '26px', width: '26px', marginRight: '10px' }}
                            />
                            Prediction Software
                        </span>
                        {/* 预测分数按卡片网格排列，提高信息密度与可扫描性 */}
                        <div className="prediction-grid">
                            {dbsnfpItem().map(item => (
                                <div className={`prediction-card ${item.value === '-' ? 'is-empty' : ''}`} key={item.key + item.label}>
                                    <span>{item.label}</span>
                                    <strong>{item.value}</strong>
                                </div>
                            ))}
                        </div>
                    </Col>
                    <Col xs={24} sm={24} className="detail-info-panel">
                        <span className='title_name' style={{ display: 'flex', alignItems: 'center', fontWeight: '700' }}>
                            <img src='https://gsrd-server.tos-cn-beijing.volces.com/gene7.png'
                                style={{ height: '30px', width: '30px', marginRight: '10px' }}
                            />
                            Gene Phenotype
                        </span>
                        <div className="phenotype-grid">
                            <div className="phenotype-card">
                                <span>GenCC</span>
                                {renderPhenotypeItems(resultInfo.Gencc_disease_title)}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row >
    )
}
